import * as v from "valibot";

export const EnvSchema = v.object({
  NODE_ENV: v.optional(v.picklist(["development", "production", "test"]), "development"),
  LOG_LEVEL: v.optional(v.picklist(["debug", "info", "warn", "error"]), "info"),
  APP_ENV: v.optional(v.picklist(["dev", "staging", "prod"]), "dev"),
  VITE_APP_ENV: v.optional(v.picklist(["dev", "staging", "prod"])),
  APP_BASE_URL: v.optional(v.pipe(v.string(), v.url())),
  API_BASE_URL: v.optional(v.pipe(v.string(), v.url())),
  PUBLIC_WEB_BASE_URL: v.optional(v.pipe(v.string(), v.url())),
  PRODUCT_APP_ORIGIN: v.optional(v.pipe(v.string(), v.url())),
  PUBLIC_ORIGIN: v.optional(v.pipe(v.string(), v.url())),
  ADMIN_ORIGIN: v.optional(v.pipe(v.string(), v.url())),
  APP_ORIGIN: v.optional(v.pipe(v.string(), v.url())),
  ADMIN_BASE_URL: v.optional(v.pipe(v.string(), v.url())),
  ADMIN_CF_ACCESS_REQUIRED: v.optional(v.string()),
  ADMIN_CF_ACCESS_TEAM_DOMAIN: v.optional(v.string()),
  ADMIN_CF_ACCESS_AUDIENCE: v.optional(v.string()),
  ADMIN_ALLOWED_EMAILS: v.optional(v.string()),
  BETTER_AUTH_SECRET: v.optional(v.string()),
  BETTER_AUTH_URL: v.optional(v.pipe(v.string(), v.url())),
  BETTER_AUTH_TRUSTED_ORIGINS: v.optional(v.string()),
  BETTER_AUTH_COOKIE_DOMAIN: v.optional(v.string()),
  BOOTSTRAP_ADMIN_EMAILS: v.optional(v.string()),
  INVITE_FROM_EMAIL: v.optional(v.pipe(v.string(), v.email())),
  SENTRY_DSN: v.optional(v.string()),
  SENTRY_RELEASE: v.optional(v.string()),
  SENTRY_SMOKE_TOKEN: v.optional(v.string()),
  SENTRY_TRACES_SAMPLE_RATE: v.optional(v.string()),
  SENTRY_TRACES_HEAD_SAMPLE_RATE: v.optional(v.string()),
  SENTRY_SLOW_TRANSACTION_MS: v.optional(v.string()),
  SENTRY_REPLAY_SESSION_SAMPLE_RATE: v.optional(v.string()),
  SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE: v.optional(v.string()),
  VITE_SENTRY_DSN: v.optional(v.string()),
  VITE_SENTRY_RELEASE: v.optional(v.string()),
  VITE_SENTRY_TRACES_SAMPLE_RATE: v.optional(v.string()),
  VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE: v.optional(v.string()),
  VITE_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE: v.optional(v.string()),
  OPENFEATURE_FLAG_OVERRIDES: v.optional(v.string()),
  VITE_OPENFEATURE_FLAG_OVERRIDES: v.optional(v.string()),
  POSTHOG_PROJECT_API_KEY: v.optional(v.string()),
  POSTHOG_HOST: v.optional(v.pipe(v.string(), v.url())),
  CF_AIG_BASE_URL: v.optional(v.pipe(v.string(), v.url())),
  CF_AIG_API_KEY: v.optional(v.string()),
  CF_AIG_MODEL: v.optional(v.string()),
  R2_BUCKET: v.optional(v.string()),
  R2_PUBLIC_BASE_URL: v.optional(v.pipe(v.string(), v.url())),
  STRIPE_SECRET_KEY: v.optional(v.string()),
  STRIPE_WEBHOOK_SECRET: v.optional(v.string()),
  STRIPE_API_VERSION: v.optional(v.string()),
  STRIPE_PREVIEW_HEADER: v.optional(v.string()),
  STRIPE_CHECKOUT_SUCCESS_URL: v.optional(v.pipe(v.string(), v.url())),
  STRIPE_CHECKOUT_CANCEL_URL: v.optional(v.pipe(v.string(), v.url())),
  STRIPE_CUSTOMER_PORTAL_RETURN_URL: v.optional(v.pipe(v.string(), v.url())),
  STRIPE_PRICE_PRO_MONTHLY_ID: v.optional(v.string()),
  STRIPE_PRICE_PRO_YEARLY_ID: v.optional(v.string()),
  STRIPE_PRICE_TEAM_MONTHLY_ID: v.optional(v.string()),
  STRIPE_PRICE_TEAM_YEARLY_ID: v.optional(v.string()),
  BILLING_PRO_MONTHLY_AMOUNT: v.optional(v.string()),
  BILLING_PRO_YEARLY_AMOUNT: v.optional(v.string()),
  BILLING_TEAM_MONTHLY_AMOUNT: v.optional(v.string()),
  BILLING_TEAM_YEARLY_AMOUNT: v.optional(v.string()),
  APP_STORE_SHARED_SECRET: v.optional(v.string()),
  APP_STORE_BUNDLE_ID: v.optional(v.string()),
  APP_STORE_WEBHOOK_SECRET: v.optional(v.string()),
  GOOGLE_PLAY_PACKAGE_NAME: v.optional(v.string()),
  GOOGLE_PLAY_WEBHOOK_SECRET: v.optional(v.string()),
});

export type Env = v.InferOutput<typeof EnvSchema>;
